export const getElapsedTimeMs = (
  sliTimerStartTime: number | undefined
): number => {
  const sliTimerEndTime = Date.now();
  return sliTimerStartTime ? sliTimerEndTime - sliTimerStartTime : 0;
};
